<template>
  <div class="block div-mg-all">
    <el-image :src="imgSrc" style="width: 100%; height:80%;" fit="fill" ></el-image>
  </div>
</template>

<script>
export default {
  name: "MainPlugin",
  props: {
    imgSrc: {
      type: String,
      default: require('../assets/images/gw.png')
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
